import { useContent } from "@/context/ContentContext";
import useMeta from "@/hooks/useMeta";
import { Reveal } from "@/components/site/Reveal";
import { PageHero } from "@/components/site/PageHero";
import { CtaBand } from "@/components/site/CtaBand";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";

export default function Faq() {
  const { content } = useContent();
  const q = content.faq;
  useMeta(
    "FAQ · Online psychotherapy Ontario",
    "Answers about virtual therapy in Ontario: first sessions, online effectiveness, confidentiality, insurance, cancellation, and crisis support."
  );
  return (
    <>
      <PageHero eyebrow="FAQ" title={q.headline} testId="faq-headline" />
      <section className="wrap pb-10">
        <Reveal>
          <Accordion type="single" collapsible className="card-soft px-6 sm:px-10" data-testid="faq-accordion">
            {q.items.map((it, i) => (
              <AccordionItem key={it.q} value={`item-${i}`} className="border-[#B9A9D8]/40 last:border-0">
                <AccordionTrigger className="py-6 text-left font-display text-xl text-[#22304A] hover:text-[#6F5B9E] hover:no-underline sm:text-2xl" data-testid={`faq-item-trigger-${i}`}>
                  {it.q}
                </AccordionTrigger>
                <AccordionContent className="pb-6 text-base leading-relaxed text-[#22304A]/80" data-testid={`faq-item-content-${i}`}>
                  {it.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </Reveal>
      </section>
      <CtaBand title={content.home.final_cta_title} button={content.home.final_cta_button} />
    </>
  );
}
